import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useStatistics = ({
	participantId,
	firstRangeStartDate,
	firstRangeEndDate,
	type,
	lastRangeStartDate,
	lastRangeEndDate,
}: {
	participantId: number;
	firstRangeStartDate: string;
	firstRangeEndDate: string;
	type: string;
	lastRangeStartDate: string;
	lastRangeEndDate: string;
}) => {
	const queryClient = useQueryClient();
	const queryKey = [
		"statistics",
		{
			participantId,
			firstRangeStartDate,
			type,
			firstRangeEndDate,
			lastRangeStartDate,
			lastRangeEndDate,
		},
	];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getStatistics({
				participantId,
				config: {
					params: {
						firstRangeStartDate,
						firstRangeEndDate,
						type,
						lastRangeStartDate,
						lastRangeEndDate,
					},
				},
			});
			return response;
		},

		// We can get new data every 4 hours
		staleTime: 1000 * 60 * 60 * 4,
	});

	return {
		...query,
		invalidate: () => queryClient.invalidateQueries({ queryKey }),
	};
};
